import instaClone from '../../assets/InstaClone.png'
import mealHelpr from '../../assets/MealHelpr.png';
import notesApp from '../../assets/Notes.png';
import constrImg from '../../assets/construct.png';

const generateRows = () => {
  const rows = [
    {
      title: "MealHelpr",
      image: mealHelpr,
      content: `
      <p> An app made for meal tracking and general health.</p>
      <p>Deploy: <a target="_blank" rel="noopener noreferrer" href="https://meal-helper-development.netlify.app/">MealHelper</a></p>
      <p>Github: <a target="_blank" rel="noopener noreferrer" href="https://github.com/Lambda-School-Labs/Labs8-MealHelper">Here</a></p>
      `
    },
    {
      title: "Petfindr",
      image:
        "https://github.com/PatrickTheCodeGuy/PetFindr/blob/master/images/Design_Pet.png?raw=true",
      
      content: `
      <p>An app developed to help pets find their furever home. Currently moving to open source.</p>
      <p>Made with: React Native, MongoDB</p>
      <p>Github: <a target="_blank" rel="noopener noreferrer" href="https://github.com/PatrickTheCodeGuy/PetFindr">Here</a></p>
      `
    },
    {
      title: "InstaClone",
      image:
        instaClone,
      
      content: `
      <p>An imitation of the older instagram design. Nothing is saved to a server, localStroage is used then cleared on exit. <p/>
      <p>Made with: React, Netlify</p>

      <p>Deploy: <a target="_blank" rel="noopener noreferrer" href="https://instagramclonesite.netlify.app/">InstaClone</a></p>
      <p>Github: <a target="_blank" rel="noopener noreferrer" href="https://github.com/PatrickTheCodeGuy/PetFindr">Here</a></p> 
      `
    },
    {
      title: "Notes App",
      image:
        notesApp,
      
      content: `
      <p>Your average developers first notes app.</p>
      <p>Made with: React, Netlify</p>

      <p>Deploy: <a target="_blank" rel="noopener noreferrer" href="https://instagramclonesite.netlify.app/">Notes App</a></p>
      <p>Github: <a target="_blank" rel="noopener noreferrer" href="https://github.com/PatrickTheCodeGuy/PetFindr">Here</a></p>
      `
    },
    {
      title: "weatherU",
      image:
        constrImg,
      
      content: `
      <p>An social media app that lets you post on a general wall with your weather and location.</p>
      
      <p>No longer deployed as co-designer wants it down.</p>
      
      <p>Made with: React Native, MongoDB</p>
      <p>Github: <a target="_blank" rel="noopener noreferrer" href="https://github.com/PatrickTheCodeGuy/weatherU">Here</a></p>
      `
    },
    
  ];

  return rows
    .map(
      r => `
    <tr>
      <td bgcolor="black" width="120px" align="right">
        <font color="white" style="font-size: 28px;" id="introduction">
          ${r.title}<br/>
          <img src="${r.image}" width="300px" />
        </font>
      </td>
      <td bgcolor="lightgrey">
        ${r.content}
      </td>
    </tr>
  `
    )
    .join("");
};

const marqueeGen = () =>
  [
    {
      href: "https://github.com/PatrickTheCodeGuy",
      title: "Github"
    },
    {
      href: "https://www.linkedin.com/in/patrick-thompson-the-code-guy/",
      title: "LinkedIn"
    }
  ]
    .map(
      l =>
        `<a href="${l.href}" target="_blank" norel="noopen noreferrer">${
          l.title
        }</a>`
    )
    .join(" | ");

export default `
<style>
font * {font-family: 'Comic Sans MS' !important;}
blink {
  -webkit-animation: 1s linear infinite condemned_blink_effect; // for android
  animation: 1s linear infinite condemned_blink_effect;
}
@-webkit-keyframes condemned_blink_effect { // for android
  0% {
      visibility: hidden;
  }
  50% {
      visibility: hidden;
  }
  100% {
      visibility: visible;
  }
}
@keyframes condemned_blink_effect {
  0% {
      visibility: hidden;
  }
  50% {
      visibility: hidden;
  }
  100% {
      visibility: visible;
  }
}
</style>
<font size="4" >
  <table bgcolor="grey" width="100%">
    <thead>
    
      <tr>
        <td colspan="2" valign="center">
          <font size="7"><b>README(Projects)</b></font>
          ${marqueeGen()}
        </td>
      </tr>
    </thead>
    <tbody valign="top">
      ${generateRows()}
    </tbody>
    <tfoot valign="top">
      <tr><td>(c)1999</td>
      <td>
      </td></tr>
    </tfoot>
  </table>
 </font>
`;
